import { ShopType, CheckoutType, MultiProviderConfig } from 'types';
import { asyncEligible } from 'config/sharedFunctions';
import { ProviderConfigList } from 'config/providers';
import { StarryTheme } from 'config/themes';

export const StarryIFramed: MultiProviderConfig = {
  name: 'StarryIFramed',
  displayName: 'Starry',
  micrositeCode: 'StarryIFrame',
  shopType: ShopType.MULTI_PROVIDER,
  domain: 'updater.com',
  homepage: '',
  title: 'Compare and shop for internet & TV with Starry',
  fallbackPhoneNumber: '888-598-7495',
  fallbackLeadModePhoneNumber: '888-598-7493',
  defaultCheckoutType: CheckoutType.LEAD_MODE,
  defaultTheme: StarryTheme,
  needsDcSession: false,
  updaterCrossSellActive: false,
  source: 'StarryIFrame',
  noOffersRetry: 2,
  providers: ProviderConfigList.filter(
    (provider) =>
      provider.providerCode !== 'earthlink' && provider.providerCode !== 'tds'
  ),
  movingAppBuyflowUrls: {
    development: 'http://bridgevine.io:3000/guest/tvi/buy',
    staging: 'https://staging-partner-cart.updater.com/guest/tvi/buy',
    qa: 'https://staging-partner-cart.updater.com/guest/tvi/buy',
    production: 'https://partner-cart.updater.com/guest/tvi/buy',
  },
  getCheckoutType: asyncEligible,
  iFrameConfig: {
    hideHeaderAndFooter: true,
    trustedHosts: {
      production: ['starry.com'],
    },
  },
};
